import { InsightService } from '@pepper/insights-react';
import { useCallback, useContext } from "react";

import { PromotionsData, StandardPaymentsData, CoLoanData, TransactionReasonEnum } from './../../interfaces/Debt';
import { PaymentSelectedContext } from './payment-selected-context';


export const usePaymentSelected = () => {
  const { paymentSelected, setPaymentSelected } = useContext(PaymentSelectedContext);
  const { coPaymentSelected, setCoPaymentSelected } = useContext(PaymentSelectedContext);

  const createPaymentSelected = useCallback(
    (newPaymentSelected: PromotionsData | StandardPaymentsData | undefined): void => {
      setPaymentSelected(newPaymentSelected);
      newPaymentSelected && InsightService.logTrace("DebtSelected", [
        { transaction_reason: newPaymentSelected.transaction_reason },
        { debt_amount: newPaymentSelected.amount.toString() },
        { loan_id: newPaymentSelected.loan_id },
        { type: newPaymentSelected.type }
      ]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [paymentSelected]
  );

  const createCoPaymentSelected = useCallback(
    (newPaymentSelected: CoLoanData | undefined): void => {
      setCoPaymentSelected(newPaymentSelected);
      newPaymentSelected && InsightService.logTrace("DebtCoSelected", [
        { transaction_reason: TransactionReasonEnum.DEC },
        { debt_amount: (newPaymentSelected?.certified_debt ?? 0).toString() },
        { loan_id: newPaymentSelected.loan_id },
        { type: newPaymentSelected.product_type }
      ]);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [coPaymentSelected]
  );

  const deletePaymentSelected = useCallback((): void => {
    setPaymentSelected(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentSelected]);

  const deleteCoPaymentSelected = useCallback((): void => {
    setCoPaymentSelected(undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coPaymentSelected]);

  return {
    paymentSelected,
    coPaymentSelected,
    createPaymentSelected,
    createCoPaymentSelected,
    deletePaymentSelected,
    deleteCoPaymentSelected
  };
};
